import { IFormFieldType } from '@/widgets/create-widget'
import { MediaType } from '@/constants/constants'

const HandsOnLearningSectionSchema: { [key: string]: IFormFieldType } = {
  handsOnLearningSection: {
    type: 'Object',
    label: 'Hands On Learning Section',
    required: false,
    children: {
      heading: {
        type: 'String',
        label: 'Heading',
        required: false,
      },
      subHeading: {
        type: 'String',
        label: 'Sub Heading',
        required: false,
      },
      features: {
        type: 'List',
        label: 'Cards',
        required: false,
        children: {
          title: {
            type: 'String',
            label: 'Title',
            required: false,
          },
          description: {
            type: 'String',
            label: 'Description',
            required: false,
          },
          videoUrl: {
            type: 'Media',
            mediaTypes: [MediaType.VIDEO],
            label: 'Video URL',
            required: false,
          },
          thumbnail: {
            type: 'Media',
            mediaTypes: [MediaType.IMAGE],
            label: 'Thumbnail',
            required: false,
          },
        },
      },
      getStartedButtonText: {
        type: 'String',
        label: 'Get Started Button Text',
        required: false,
      },
    },
  },
}

export default HandsOnLearningSectionSchema

export type handsOnLearning = {
  handsOnLearningSection: HandsOnLearningSectionProps
}

export type HandsOnLearningFeatureProps = {
  title: string
  description: string
  videoUrl: string
  thumbnail?: string
}

export type HandsOnLearningSectionProps = {
  heading: string
  subHeading: string
  features: HandsOnLearningFeatureProps[]
  getStartedButtonText: string
}

export const HandsOnLearningSectionDefaultValues: handsOnLearning = {
  handsOnLearningSection: {
    heading: 'Hand’s-On Learning and More!',
    subHeading: 'Explore Our Latest Product Features',
    features: [
      {
        title: 'Interactive Live Classes',
        description: 'Interactive elements, engaging animations, and badges for learning fun and effective.',
        videoUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/ad009079-3273-45ae-9a7a-96fa8868cd76.mp4',
        thumbnail: '',
      },
      {
        title: 'The Two-Teacher Model',
        description: 'A dedicated educator for quality teaching & a personal mentor to guide your child.',
        videoUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/27f09fef-f89b-4ba9-9c78-30b4a5c42358.mp4',
      },
      {
        title: 'Tailored Practice Solutions',
        description: "Practice exercises designed to reinforce concepts & help in your child's learning.",
        videoUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/c48cfce2-0a81-437a-8c83-98f993be654f.mp4',
      },
      {
        title: 'Homework Assistance',
        description: 'No more homework struggles! Get real-time homework support from our Mentors.',
        videoUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/fbb16af4-8e44-4382-bec8-b00541f38246.mp4',
      },
      {
        title: 'Daily Performance Tracking',
        description: "Stay connected with your child's learning journey through our progress reports.",
        videoUrl:
          'https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/b0f83d25-ebe3-45f2-a7ac-fd2065bc75c5.mp4',
      },
    ],
    getStartedButtonText: 'Get Started',
  },
}
